// import AuthLayout from "../../components/";
import { Button, Col, Image, Layout, List, Row } from "antd";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router";
import { ImageUrl } from "../../helpers/Function";
// import router from "next/router";

function Safety() {
  const navigate = useNavigate();

  const data1 = [
    {
      title: "Attach a logo to the portal.",
    },
    {
      title: "Create a referral code for users to self-enroll into a portal.",
    },
  ];

  return (
    <>
      <Layout style={{ minHeight: "100vh", backgroundSize: "cover" }}>
        <section className="bg-white top-bottom-padding two-colum-white">
          <Row justify={"center"}>
            <Col lg={19}>
              <Row justify={"center"} gutter={[32, 32]} className="gutter-0">
                <Col xs={24} sm={24} md={12}>
                  <div className="c-img">
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      src={ImageUrl("c49.jpeg")}
                    />
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="">
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      src={ImageUrl("miniImg4.png")}
                    />
                    <h4>
                    Carpet Cleaning and Maintenance – Cleaning for Health
                    </h4>
                    <p className="text-p-16">Duration:2 Hours 30 Minutes</p>
                    <h5 className="c-heading">Who Should Attend</h5>
                    <p className="text-p-16">
                    Custodial Supervisor, Custodial Staff
                    </p>

                    <h5 className="c-heading">Description</h5>

                    <p className="text-p-16">
                    The training focuses on the vital role carpets play in children’s health, classroom image, and the financial investment of organizations. Proper carpet maintenance and cleaning are essential for extending the carpet’s lifespan, improving its health, and preserving its appearance. The training program aims to equip maintenance staff with comprehensive carpet care theory and best practices for effective carpet cleaning. Participants will gain valuable insights into daily, interim, and restorative carpet cleaning methods, along with the appropriate equipment, chemicals, and tools required for each process.
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </section>

        <section className="bg-white top-bottom-padding two-colum-white">
          <Row justify={"center"}>
            <Col lg={19}>
              <Row justify={"center"} gutter={[32, 32]} className="gutter-0">
                <Col xs={24} sm={24} md={12}>
                  <div className="c-img">
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      src={ImageUrl("c50.png")}
                    />
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="">
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      src={ImageUrl("miniImg4.png")}
                    />
                    <h4>
                    Mastering Time, Task and Team Management for Custodians
                    </h4>
                    <p className="text-p-16">Duration:2 Hours 30 Minutes</p>
                    <h5 className="c-heading">Who Should Attend</h5>
                    <p className="text-p-16">
                    Custodians and Custodial Supervisors
                    </p>

                    <h5 className="c-heading">Description</h5>

                    <p className="text-p-16">
                    This is a hands-on seminar designed to equip custodians with practical skills and insights to excel in the art of self management. By the end of this comprehensive training, attendees will possess a firm grasp of the policy and compliance elements that underpin effective custodial scheduling. Uncover the nuances between zone and team cleaning strategies, while also delving into the preparation and execution of task schedules. With a focus on optimizing efficiency and effectiveness, this training delves into best practices that are instrumental in elevating custodians’ performance. The supervisor’s role and essential tools are introduced, enabling participants to navigate the intricaties of daily, weekly, monthly, and annual tasks.
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </section>
      </Layout>
    </>
  );
}

export default Safety;
